module.exports = __webpack_public_path__ + "7402b60f949c24f03aadce8eddc3f81b.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_2_sq.mp3
 ** module id = 172
 ** module chunks = 0
 **/